import src from "IMAGE";
export default { src, width: 645, height: 142, blurWidth: 0, blurHeight: 0};
